import {
  authAuthorizeUser,
  authFetchOtpCodeByPhone,
  authVerifyOtpCode,
  authRefreshTokens,
  authFetchProfile,
  authCheckUserProfile,
  authRegister,
  authExchangeExternalToken,
} from "../api";
import type {
  IFetchOTPCodeBody,
  IVerifyOTPCodeBody,
  IAuthorizeUserBody,
  IRefreshTokensBody,
  IRegisterBody,
  IUseAuthApiOptions,
} from "../types";

export default (options: IUseAuthApiOptions) => {
  const {
    transport,
    authorizeUser,
    fetchOtpCodeByPhone,
    verifyOtpCode,
    refreshTokens,
    fetchProfile,
    register,
    checkUserProfile,
    exchangeExternalToken,
  } = options;
  const getErrorMessage = (method: string) => {
    if (import.meta.env.DEV)
      return `util-auth/useAuthApi/${method} невозможно выполнить запрос, так как не предоставлен экземпляр ofetch для транспорта и не предоставлен локальный метод запроса в качестве options`;
    else return "Что-то пошло не так";
  };
  return {
    authorizeUser: (b: IAuthorizeUserBody) => {
      if (!authorizeUser && !transport)
        throw new Error(getErrorMessage("authorizeUser"));
      if (authorizeUser) return authorizeUser(b);
      if (transport) return authAuthorizeUser(transport, b);
    },
    fetchOtpCodeByPhone: (b: IFetchOTPCodeBody) => {
      if (!fetchOtpCodeByPhone && !transport)
        throw new Error(getErrorMessage("fetchOtpCodeByPhone"));
      if (fetchOtpCodeByPhone) return fetchOtpCodeByPhone(b);
      if (transport) return authFetchOtpCodeByPhone(transport, b);
    },
    verifyOtpCode: (b: IVerifyOTPCodeBody) => {
      if (!verifyOtpCode && !transport)
        throw new Error(getErrorMessage("verifyOtpCode"));
      if (verifyOtpCode) return verifyOtpCode(b);
      if (transport) return authVerifyOtpCode(transport, b);
    },
    refreshTokens: (b: IRefreshTokensBody) => {
      if (!refreshTokens && !transport)
        throw new Error(getErrorMessage("refreshTokens"));
      if (refreshTokens) return refreshTokens(b);
      if (transport) return authRefreshTokens(transport, b);
    },
    fetchProfile: () => {
      if (!fetchProfile && !transport)
        throw new Error(getErrorMessage("fetchProfile"));
      if (fetchProfile) return fetchProfile();
      if (transport) return authFetchProfile(transport);
    },
    checkUserProfile: () => {
      if (!checkUserProfile && !transport)
        throw new Error(getErrorMessage("checkUserProfile"));
      if (checkUserProfile) return checkUserProfile();
      if (transport) return authCheckUserProfile(transport);
    },
    register: (b: IRegisterBody) => {
      if (!register && !transport) throw new Error(getErrorMessage("register"));
      if (register) return register(b);
      if (transport) return authRegister(transport, b);
    },
    exchangeExternalToken: (token: string) => {
      if (!exchangeExternalToken && !transport)
        throw new Error(getErrorMessage("exchangeExternalToken"));
      if (exchangeExternalToken) return exchangeExternalToken(token);
      if (transport) return authExchangeExternalToken(transport, token);
    },
  };
};
